import { LabelPrintCommands } from '../LabelPrintCommands';
import LabelPrintErrors from '../LabelPrintErrors';
import ZebraWebDriverModule from './ZebraWebDriver.min';

const ZebraWebDriver = ZebraWebDriverModule();

/**
 * Promise that returns the list of available local printers using Zebra SDK
 * @returns {Promise}
 */
export const getLocalPrinters = () =>
  new Promise((resolve, reject) => {
    ZebraWebDriver.getLocalDevices(
      (printers) => {
        resolve(printers);
      },
      (error) => {
        reject(error);
      },
      'printer'
    );
  });

/**
 * Promise that returns the list of available local printers
 * @returns {Promise}
 */
export const getPrinterStatus = (printer) =>
  new Promise((resolve) => {
    printer.sendThenRead(LabelPrintCommands.getStatus, (status) => {
      resolve(LabelPrintErrors.getErrorFromStatus(status));
    });
  });

/**
 * Extract the API link and request the label data
 * @param {String} labelApiUrl - API Url to request the label data from
 * @returns {Promise}
 */
export const getLabelData = (labelApiUrl) =>
  new Promise((resolve, reject) => {
    if (!labelApiUrl) {
      reject('Missing to API Url parameter.');
    } else {
      window.lsCloud.getJSONFromAPI(labelApiUrl.replace('.html', '.json')).then(
        (labelData) => {
          resolve(labelData);
        },
        (error) => {
          reject(error);
        }
      );
    }
  });

export const getDefaultPrinter = (printers) => {
  const localStoragePrinter = localStorage.getItem('LABEL_PRINTER');

  let printer = null;

  if (localStoragePrinter) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0, ii = printers.length; i < ii; ++i) {
      if (printers[i].uid.trim() === localStoragePrinter) {
        printer = printers[i];
        break;
      }
    }
  }

  if (!printer) {
    printer = printers[0];
  }

  return printer;
};

/**
 * Queries the printer for the full identification using ~HI but specifically returns the model & firmware
 * @returns {Promise<{ model: string; firmware: string }>} Model
 */
export function getLabelPrinterModel(printer) {
  return new Promise((resolve) => {
    printer.sendThenRead(LabelPrintCommands.hostIdentification, (identification) => {
      const [model, firmware] = identification.split(',');
      resolve({
        model: model.replace('\u0002', ''),
        firmware,
      });
    });
  });
}
